import React, { ChangeEvent, useCallback, useState } from 'react';
import { GridRowParams } from '@material-ui/data-grid';
import { toast } from 'react-toastify';
import Search from '~/components/Search';
import { schema } from './validations';
import { Container } from './styles';
import FormDefault from '~/components/FormDefault';
import api from '~/services/api';
import ToggleDefault from '~/components/ToggleDefault';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { InputTextArea, InputText } from '~/components/NovosInputs';
import { formReceitaBlank } from './protocols';
import DefaultLoader from '~/components/DefaultLoader';

const CadastroReceita: React.FC = () => {
  const [loader, setLoader] = useState<boolean>(false);
  const [isUpdate, setUpdate] = useState<boolean>(false);
  const [showSearch, setShowSearch] = useState<boolean>(true);
  const [flgGluten, setFlgGluten] = useState<boolean>(false);

  const {
    handleSubmit,
    register,
    control,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    reValidateMode: 'onBlur',
  });

  const handlePasteWeight = useCallback(
    (detalhamento) => {
      if (detalhamento.length > 1990) {
        return setValue('des_formula', detalhamento.substring(0, 1990));
      }
      setValue('des_formula', detalhamento);
    },
    [setValue],
  );

  const onRowClick = async (param: GridRowParams) => {
    setLoader(true);
    const { row } = param;

    const { cod_receita, des_receita, flg_gluten, des_formula } = row;

    reset({
      cod_receita,
      des_receita,
      des_formula,
    });
    setFlgGluten(flg_gluten);

    setUpdate(true);
    setShowSearch(false);
    setLoader(false);
  };

  const resetFormReceita = () => {
    setUpdate(false);
    setFlgGluten(false);
    reset(formReceitaBlank);
  };

  const onCancel = () => {
    resetFormReceita();
    setShowSearch(true);
  };

  const onNew = () => {
    resetFormReceita();
    setShowSearch(false);
    setUpdate(false);
  };

  const onDelete = async () => {
    const { data } = await api.delete(`/receita/${watch('cod_receita')}`);

    if (data.success) {
      resetFormReceita();
      setShowSearch(true);
      return toast.success(data.message);
    }
  };

  const onSave = handleSubmit(async (dataForm1) => {
    if (
      dataForm1.des_receita.trim() === 'NENHUM' ||
      dataForm1.des_receita.trim() === 'NENHUMA' ||
      dataForm1.des_receita.trim() === 'NENHUM(A)'
    ) {
      return toast.warn(
        'Descrição contém palavra não permitida "Nenhum/Nenhuma".',
      );
    }

    try {
      const dataForm = {
        des_receita: dataForm1.des_receita,
        flg_gluten: flgGluten,
        des_formula: dataForm1.des_formula,
      };

      if (isUpdate) {
        const { data } = await api.put(
          `/receita/${watch('cod_receita')}`,
          dataForm,
        );

        if (data.success) {
          toast.success(data.message);
          resetFormReceita();
          setShowSearch(true);
        }
        return;
      }
      const { data } = await api.post('/receita', dataForm);

      if (data.success) {
        toast.success(data.message);
        resetFormReceita();
      }
    } finally {
      setLoader(false);
    }
  });

  if (loader) {
    return <DefaultLoader />;
  }

  return (
    <Container>
      {showSearch && (
        <Search newData={onNew} onRowClick={onRowClick} codTela={36} />
      )}

      {!showSearch && (
        <FormDefault
          codTela={36}
          title="Cadastro de Receita"
          onCancel={onCancel}
          codigoRegistro={[
            {
              value: watch('cod_receita'),
              des_campo: 'Código do Registro',
            },
          ]}
          onClearFields={resetFormReceita}
          onDelete={onDelete}
          onNew={onNew}
          onReturnSearch={onCancel}
          onSave={async () => {
            await onSave();
          }}
          isUpdate={isUpdate}
        >
          <div className="row">
            <div className="col-sm-12 col-md-6">
              <InputText
                label="Descrição"
                name="des_receita"
                placeholder="Informe a Descrição da Receita"
                caseInput="upper"
                register={register}
                control={control}
                maxLength={50}
                isError={!!errors.des_receita}
                onInput={(e: ChangeEvent<HTMLInputElement>) => {
                  setValue('des_receita', e.target.value);
                }}
              />
            </div>

            <div
              className="col-sm-12 col-md-2"
              style={{ textAlign: 'center', padding: '10px' }}
            >
              <ToggleDefault
                labelText="Contém Glúten?"
                setChecked={flgGluten}
                onSwitch={() => {
                  setFlgGluten(!flgGluten);
                }}
              />
            </div>

            <div className="col-12" style={{ marginTop: '20px' }}>
              <InputTextArea
                label="Fórmula da Receita"
                name="des_formula"
                placeholder="Informe o Detalhamento da Receita"
                caseInput="none"
                maxLength={1990}
                register={register}
                control={control}
                isError={!!errors.des_formula}
                onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {
                  setValue('des_formula', e.target.value);
                }}
                onPaste={(e: any) =>
                  handlePasteWeight(e.clipboardData.getData('Text'))
                }
                style={{ minHeight: '150px' }}
              />
            </div>
          </div>
        </FormDefault>
      )}
    </Container>
  );
};

export default CadastroReceita;
